"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCreatePropertyName = void 0;
const createCreatePropertyName = regex => (property, expressionAttributeNames) => {
  let propertyName = property.replace(regex, '');
  let expressionAttributeName = `#${propertyName}`;
  while (expressionAttributeName in expressionAttributeNames) {
    propertyName = `${propertyName}_`;
    expressionAttributeName = `#${propertyName}`;
  }
  expressionAttributeNames[`#${propertyName}`] = property;
  return propertyName;
};
exports.createCreatePropertyName = createCreatePropertyName;